import React from "react";
import {
  Box,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Stack,
  Typography,
  ContentCopyFilledIcon,
  ContentCutFilledIcon,
  ContentPasteOutlinedIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const IconMenu = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Icon menu
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          In desktop viewport, padding is increased to give more space to the
          menu.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          title={"Basic menu with icon"}
          value={
            "import {\n" +
            "  Box,\n" +
            "  ListItemIcon,\n" +
            "  ListItemText,\n" +
            "  MenuItem,\n" +
            "  MenuList,\n" +
            "  Paper,\n" +
            "  Typography,\n" +
            '} from "@mui/material";\n' +
            'import { ContentCopy, ContentCut, ContentPaste } from "@mui/icons-material";\n\n\n\n' +
            '<Paper sx={{ width: 320, maxWidth: "100%" }}>\n' +
            "          <MenuList>\n" +
            "            <MenuItem>\n" +
            "              <ListItemIcon>\n" +
            '                <ContentCut fontSize="small" />\n' +
            "              </ListItemIcon>\n" +
            "              <ListItemText>Cut</ListItemText>\n" +
            '              <Typography variant="body2" color="text.secondary">\n' +
            "                ⌘X\n" +
            "              </Typography>\n" +
            "            </MenuItem>\n" +
            "            <MenuItem>\n" +
            "              <ListItemIcon>\n" +
            '                <ContentCopy fontSize="small" />\n' +
            "              </ListItemIcon>\n" +
            "              <ListItemText>Copy</ListItemText>\n" +
            '              <Typography variant="body2" color="text.secondary">\n' +
            "                ⌘C\n" +
            "              </Typography>\n" +
            "            </MenuItem>\n" +
            "            <MenuItem>\n" +
            "              <ListItemIcon>\n" +
            '                <ContentPaste fontSize="small" />\n' +
            "              </ListItemIcon>\n" +
            "              <ListItemText>Paste</ListItemText>\n" +
            '              <Typography variant="body2" color="text.secondary">\n' +
            "                ⌘V\n" +
            "              </Typography>\n" +
            "            </MenuItem>\n" +
            "          </MenuList>\n" +
            "        </Paper>"
          }
        >
          <Paper sx={{ width: 320, maxWidth: "100%" }}>
            <MenuList>
              <MenuItem>
                <ListItemIcon>
                  <ContentCutFilledIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Cut</ListItemText>
                <Typography variant="body2" color="text.secondary">
                  ⌘X
                </Typography>
              </MenuItem>
              <MenuItem>
                <ListItemIcon>
                  <ContentCopyFilledIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Copy</ListItemText>
                <Typography variant="body2" color="text.secondary">
                  ⌘C
                </Typography>
              </MenuItem>
              <MenuItem>
                <ListItemIcon>
                  <ContentPasteOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Paste</ListItemText>
                <Typography variant="body2" color="text.secondary">
                  ⌘V
                </Typography>
              </MenuItem>
            </MenuList>
          </Paper>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default IconMenu;
